export const MAPS_URL = 'https://maps.app.goo.gl/wJG5qApmreQ5vQGF9';
export const FORM_ENDPOINT = 'https://formspree.io/f/xbgrpqkv';
export const CONTACT = {
  phoneLabel: '040 567 686',
  phoneHref: 'tel:+38640567686',
  email: 'tobija.siter@gmail.com'
};
export const EVENT = {
  dateLong: 'Sobota, 26. september 2026',
  dateShort: '26. 9. 2026',
  place: 'Pri Hervolu, Bukošek',
  addressLabel: 'Odpri v Google Maps'
};
export type Moment = {
  index: string;
  time: string;
  title: string;
  text: string;
  note?: string;
};
export const SCHEDULE: Moment[] = [{
  index: 'I.',
  time: '14.00',
  title: "Kosilo in druženje z otroki",
  text: "Začnemo z bolj družinskim delom praznovanja in kosilom.",
  note: 'Seveda ste na ta del vabljeni vsi, tudi če pridete brez otrok.'
}, {
  index: 'II.',
  time: '18.00',
  title: 'Prava fešta',
  text: 'Ob 18.00 se začne prava fešta. Pridružijo se še ostali, nadaljujemo z večerjo, pijačo, glasbo in žurom.'
}];